import React from 'react'

function EmbeddedContent({ url }) {
  if (url.includes('youtube.com')) {
    const videoId = url.split('v=')[1]
    return (
      <iframe
        width="560"
        height="315"
        src={`https://www.youtube.com/embed/${videoId}`}
        frameborder="0"
        allowfullscreen
      ></iframe>
    )
  } else {
    // Render a fallback for unsupported URLs
    return <p>This URL is not supported for embedding.</p>
  }
}

export default EmbeddedContent
